<template lang="pug">
  div.rss(v-if="filtered.length")
    h2(class="pointer shadow-text" :class="{'collapsed': collapsed}")
      a(:href="destinationUrl")
        span(v-html="title")
      span(class="expando" @click="collapsed = !collapsed" v-if="collapsed") &nbsp;…
      span(class="expando" @click="collapsed = !collapsed" v-else) &nbsp;⇐
    icon(v-if="busy" name="refresh" scale="3" spin)
    ul
      li(v-for="post in filtered" v-if="!collapsed && post" class="post")
        a(:href="post.link")
          span(v-if="post") {{decodeHtml(post.title)}}
        p(v-if="hide !== 'description'")
          small(v-html="post.description" v-if="post.pic && post.descriptionLength < 600")
</template>

<script>
export default {
  name: 'rss',
  props: {
    destinationUrl: { type: String },
    feedUrl: { required: true },
    title: { required: true },
    includes: { default: 'Trump' },
    collapsed: { default: false },
    hide: null
  },
  data () {
    return {
      posts: {items: []},
      errors: null,
      filtered: [],
      busy: true
    }
  },
  computed: {
  },
  methods: {
    decodeHtml (html) {
      html = html.replace(/&amp;#039;/gi, '\'')
      const txt = document.createElement('textarea')
      txt.innerHTML = html
      const val = txt.value
      // console.log(html, val)
      return val
    }
  },
  async created () {
    try {
      const rssApi = `https://api.rss2json.com/v1/api.json?rss_url=${encodeURIComponent(this.feedUrl)}`
      const response = await this.axios.get(rssApi)
      this.posts = response.data
      setTimeout(() => {
        this.filtered = this.posts.items.filter((post) => {
          post.descriptionLength = post.description.length
          post.pic = !!(post.description.indexOf('<img') >= 0)
          const re = new RegExp(this.includes, 'gi')
          return !!(post.title.match(re) && post.title.match(re).length)
        })
        this.busy = false
        // console.log(this.filtered, 'filtered')
      })
    } catch (e) {
      this.errors.push(e)
    }
  },
  mounted () {
  }
}
</script>

<style lang='stylus'>
  .expando
    color #333
    &:hover
      color #0a0a0a
  .rss
    margin: 3rem 0 3rem 3rem
    h2
      // position relative
      transition all 300ms linear
      transform-origin right right
      transform scale(1)
    h2:hover
      transform scale(1.02)
      // &:not(.collapsed):after
      //   display inline-block
      //   content '⇐'
      //   margin-left 1rem
    li
      position relative
      list-style-type none
      margin-bottom: 1rem
      @media screen and (max-width: 580px)
        margin 1em 0
      a
        font-size 0.9rem
        line-height 1.2
        letter-spacing 1px
        // margin-left -1rem
        width 100%
        display inline-block
      p
        padding-left 0rem
        margin-top 0.5rem
      &:before
        display inline-block
        content '📰'
        position absolute
        left -1.4rem
</style>



// WEBPACK FOOTER //
// RSS.vue?ac2400a8